import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

import { PageTitle } from './page-title';

type PageTitleRowProps = {
    actions?: ReactNode;
    className?: string;
} & ({ title: string; children?: never } | { title?: never; children: ReactNode });

export const PageTitleRow = ({ title, children, actions, className }: PageTitleRowProps) => (
    <div className={cn('flex items-center justify-between gap-8 px-6 py-4', className)}>
        <div className="min-w-0">{title === undefined ? children : <PageTitle>{title}</PageTitle>}</div>
        {actions}
    </div>
);
